  <footer>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="footer-about">
            <h2 class="footer-title">Sorry! But the Page is not found!</h2>
          </div>
        </div>
        <div class="col-sm-12">

          <div class="col-md-6 col-sm-6 ">
            <div class="navigation">
              <h2 class="footer-title">Navigation</h2>
              <ul class="list-unstyled">
                <li class=""><a class="" routerLink="/main/info">ABOUT</a></li>
                <li class=""><a class="" [routerLink]="['/main/people']">PEOPLE</a></li>
                <li class=""><a class="" routerLink="/main/area">RESEARCH</a></li>
                <li class=""><a class="" routerLink="/main/news">NEWS & EVENT</a></li>
                <li class=""><a class="" routerLink="/main/downloads">ARCHIVE</a></li>
              </ul>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </footer>


// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/error/error.component.html